

























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
import { ReportType } from '../models/reportType';
import { Data, DataFilter, DateGrouping, DateOption, Series } from '@/features/reports/models';
import { FluentDate, nlpReportApi } from '@/features/reports/services';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import DoughnutChart from '../components/chartjs/DoughnutChart.vue';
import HorizontalThresholdBarChart from '../components/chartjs/HorizontalThresholdBarChart.vue';
import LineChart from '../components/chartjs/LineChart.vue';
import Report from '../components/Report.vue';
import { ChartDataFormat } from '@/features/reports/models/chartDataFormat';
import { SET_REPORT_LOADING } from '@/store/reports/mutationTypes';

@Component({
	mixins: [],
	components: {
		DoughnutChart,
		HorizontalThresholdBarChart,
		LineChart,
		Report
	}
})
export default class IntentsReports extends Vue {

	@Getter public currentWorkspace!: WorkspaceViewModel;
	@Getter public selectedDateOption!: DateOption;

	@Mutation(SET_REPORT_LOADING) public setLoading: (loading: boolean) => void;

	public mostPopularTotals: Data = { series: [], scale: { labels: [], title: '' } };
	public lowestConfidenceTotals: Data = { series: [], scale: { labels: [], title: '' } };
	public highestConfidenceTotals: Data = { series: [], scale: { labels: [], title: '' } };

	public mostPopularTrends: Data = { series: [], scale: { labels: [], title: '' } };
	public lowestConfidenceTrends: Data = { series: [], scale: { labels: [], title: '' } };

	public highestConfidenceTrends: Data = { series: [], scale: { labels: [], title: '' } };
	public averageConfidence: number = 0;

	public loadingError: boolean = false;
	public loadedData: boolean = false;

	public highestLabelValues: Map<string, string> = new Map<string, string>();
	public lowestLabelValues: Map<string, string> = new Map<string, string>();

	@Watch('selectedDateOption', { immediate: true })
	public async onFilterChange(filter: DateOption, previous: DateOption) {
		if (filter && filter === previous) {
			return;
		}

		await this.renderReportData();
	}

	public async renderReportData() {
		if (!this.isReportCriterionValid()) {
			return;
		}
		this.loadedData = false;
		this.loadingError = false;
		this.setLoading(true);

		try {
			await this.loadReportData();
			this.loadedData = true;
		} catch {
			this.loadingError = true;
		} finally {
			this.setLoading(false);
		}
	}

	public isReportCriterionValid(): boolean {
		return !!this.selectedDateOption;
	}

	public async loadReportData(): Promise<void> {
		const filterRange = this.selectedDateOption.getDateRange();
		const responseData = await nlpReportApi.get(this.currentWorkspace.id, {
			startDate: filterRange.start,
			endDate: filterRange.end,
			grouping: this.selectedDateOption.group
		});

		this.mostPopularTotals = responseData.mostPopularTotalsReport;
		this.lowestConfidenceTotals = responseData.lowestConfidenceTotalsReport;
		this.highestConfidenceTotals = responseData.highestConfidenceTotalsReport;
		this.averageConfidence = responseData.confidenceAverage;
		this.highestConfidenceTrends = responseData.highestConfidenceTrendReport;

		this.mostPopularTrends = responseData.mostPopularTrendReport;
		this.lowestConfidenceTrends = responseData.lowestConfidenceTrendReport;

		this.setAverageLabels();
	}

	public isDataEmpty(data: Data) {
		if (!data)  {
			return false;
		}
		return data.scale.labels.length < 1 || data.series.length < 1;
	}

	private setAverageLabels() {
		this.setLabels(this.highestConfidenceTotals, this.highestLabelValues);
		this.setLabels(this.lowestConfidenceTotals, this.lowestLabelValues);
	}

	private setLabels(data: Data, labels: Map<string, string>) {
		if (!this.isDataEmpty(data)) {
			data.series[0].data.forEach((average, index) => {
				const roundedAverage = Math.round(average * 1000) / 1000;
				labels.set(data.scale.labels[index], roundedAverage.toString());
			});
		}
	}

}
